import { useMutation, gql } from '@apollo/client'
import { campaignsClient } from '../../../utils/apollo/api'

const MUTATION = gql`
  mutation UpsertViewedCampaign($campaignId: String, $userId: Int) {
    upsertViewedCampaign(input: { campaignId: $campaignId, userId: $userId }) {
      id
    }
  }
`

const useMarkAsViewedRequest = () => {
  const [request, state] = useMutation(MUTATION, { client: campaignsClient })

  const handleRequest = (campaignId, userId) => request({ variables: { campaignId, userId } })

  return [handleRequest, state]
}

export default useMarkAsViewedRequest
